module.exports = __webpack_public_path__ + "static/img/icon-sm.655b81d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-sm.png
// module id = VwCb
// module chunks = 1 3 4 5 6 7